
import Vue from 'vue'
import NavTooltip from '@/components/userProfile/NavTooltip.vue'
import Header from '@/components/layout/Header.vue'
import Navigation from '@/components/userProfile/Navigation.vue'
import NavDrawerItems from '@/components/layout/NavDrawerItems.vue'
import ViewProfileIcon from '@/assets/svgs/view_profile_icon.svg?inline'
import BackLink from '@/components/atoms/BackLink.vue'

export default Vue.extend({
  name: 'UserProfileLayout',
  components: {
    NavTooltip,
    Header,
    Navigation,
    NavDrawerItems,
    ViewProfileIcon,
    BackLink,
  },
  data: () => ({
    isSearchTabExpanded: false,
    shouldShowNavigationWarning: false,
    drawerOpen: false,
  }),
  methods: {
    goBackToSummit: function () {
      window.location.href = process.env.VUE_APP_SUMMIT_URL!
    }
  },
  computed: {
    profilePreviewPage (): boolean {
      return this.$route.path.includes('/preview')
    },
    parentRoute (): string {
      return this.$route.params?.masqueradeUser ? `/cs/user/${this.$route.params.masqueradeUser}` : '/profile'
    }
  },
})
